module.exports = require("@aws-sdk/client-s3");